export default {
      id: "ar-menus-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-menus-usage",
      toString: function () {
        return this.url;
      }
    }